var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"virtual-loading-wrapper"},[_c('div',{staticClass:"virtual-loading"},[_c('InlineLoader',{attrs:{"size":"is-large is-gray","active":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }